import React, { useEffect } from "react";
import { StoryElement } from "@quintype/components";
import { Subheadline } from "@quintype/arrow";
import { object, bool, number, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import YouTube from "react-youtube";
import getYouTubeID from "get-youtube-id";

import AuthorAndTimeStamp from "../../story-header/author-and-timestamp";

import "./video-header-block.m.css";
import Resizer from "../../story-header/resizer";

const DmPlayer = ({ story, element }) => {
  useEffect(() => {
    const dmscript = document.createElement("script");
    dmscript.id = "dailymotion-script";
    dmscript.src = "https://srvr.dmvs-apac.com/v2/dm-ce.min.js";
    dmscript.async = true;
    document.body.appendChild(dmscript);

    return () => document.body.contains(dmscript) && document.body.removeChild(dmscript);
  }, []);

  const videoId = get(element, ["metadata", "video-id"], null);
  const metaKeywords = get(story, ["seo", "meta-keywords"], []);

  return (
    <>
      {videoId && (
        <div
          className="dm-player"
          playerId="x8f78f2"
          sort="relevance"
          owners="prajavani"
          customParams={metaKeywords}
          videoId={videoId}
        />
      )}
    </>
  );
};

DmPlayer.propTypes = {
  story: object,
  publisherName: string,
  element: object
};

const YoutubePlayer = ({ element, index }) => {
  const options = {
    playerVars: {
      autoplay: 1,
      mute: 1,
      muted: 1,
      playsinline: 1
    }
  };

  const onReady = (e) => {
    e.target.playVideo();
  };

  return <YouTube videoId={getYouTubeID(element.url)} opts={options} onReady={onReady} />;
};

YoutubePlayer.propTypes = {
  element: object,
  index: number
};

const VideoHeaderBlock = ({ story, publisherName, primaryVideo, isReview, index }) => {
  let renderTemplates = {};

  if (primaryVideo && primaryVideo.subtype === "dailymotion-video") {
    renderTemplates = { "dailymotion-video": DmPlayer };
  } else if (primaryVideo && primaryVideo.type === "youtube-video") {
    renderTemplates = { "youtube-video": YoutubePlayer };
  }
  return (
    <div styleName="wrapper">
      <div styleName="story-video">
        {primaryVideo && (
          <StoryElement
            element={primaryVideo}
            story={story}
            publisherName={publisherName}
            renderTemplates={renderTemplates}
            index={index}
          />
        )}
      </div>
      <div styleName="video-text">
        <h1 styleName="headline">{story.headline}</h1>
        <Subheadline lineClamp={10} story={story} clazzName="sub-headline" />
        <div className="author-resizer-wrapper ">
          <AuthorAndTimeStamp story={story} />
          {/* <Resizer story={story} /> */}
        </div>
      </div>
    </div>
  );
};

VideoHeaderBlock.propTypes = {
  story: object,
  primaryVideo: object,
  isReview: bool,
  index: number,
  publisherName: string
};

const mapStateToProps = (state) => ({
  publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null)
});

export default connect(mapStateToProps, null)(VideoHeaderBlock);
